import { lazy, Suspense, useMemo } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import { useNavigationItemContext } from '../context/NavigationItemProvider';

const featureComponents = {
  set: {
    unsplash: lazy(() => import('../features/Unsplash')),
    upload: lazy(() => import('../features/Upload')),
    url: lazy(() => import('../features/Url')),
  },
  crop: {
    crop: lazy(() => import('../features/Crop')),
  },
};

const Center = () => {
  const { activeItem, currentStep } = useNavigationItemContext();

  const Component = useMemo(
    () =>
      activeItem?.id ? featureComponents[currentStep]?.[activeItem.id] : null,
    [activeItem, currentStep],
  );

  return (
    <Wrapper data-testid="center-component-wrapper">
      {activeItem && (
        <Suspense fallback={null}>
          <Component />
        </Suspense>
      )}
    </Wrapper>
  );
};

export default Center;

const Wrapper = styled(Box).attrs(() => ({
  flex: 1,
  flexDirection: 'column',
  p: 5,
}))`
  overflow: scroll;
`;
